import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeUnmount, onMounted, ref } from "vue";
import { pushEvent } from "@/services/dataLayerLogin";
import { store } from "@/state/store";
import { authenticate } from "@/services/ocmAuthentication";
import { loadScript } from "@/services/utils";
import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleLogin',
  setup(__props) {

const googleButton = ref<HTMLElement | null>(null);
const messengerId = ref<number | null>(null);
const initialized = ref(false);

onMounted(() => {
	if (store.isModal) {
		messengerId.value = OcmMessenger.subscribe(messengerPublicationTypes.REQUEST_LOGIN, loadSDK);
	} else {
		loadSDK();
	}
});

onBeforeUnmount(() => {
	if (store.isModal) messengerId.value && OcmMessenger.unsubscribe(messengerId.value);
});

function loadSDK() {
	if (!googleButton.value || initialized.value) return;
	googleAuthenticationInit(googleButton.value, googleLogin);
}

function googleAuthenticationInit(googleButton: HTMLElement, _clickListener?: () => void) {
	const clickListener = typeof _clickListener === "function" ? _clickListener : () => null;
	loadScript(`https://accounts.google.com/gsi/client?_=${new Date().getTime()}`)
		.then(() => {
			// initialisiere Google (darf nur einmal passieren)
			window.google.accounts.id.initialize({
				client_id: window.ocm.config.googleClientId,
				callback: startOcmLogin,
			});

			// Rendere den Google-Button / iframe
			window.google.accounts.id.renderButton(googleButton, {
				type: "icon",
				shape: "circle",
				theme: "outline",
				text: "signin_with",
				locale: window.ocm.config.language === "de" ? "de-DE" : "en-US",
				size: "large",
				click_listener: clickListener,
			});
			initialized.value = true;
		})
		.catch(() => {
			pushEvent("google_load_error");
			// no Error-Message needed, Google Button will not be rendered
		});
}

function googleLogin() {
	// todo todo TUB-18950: remove suffix after AB-Test
	const suffix = store.abTestIsTestPage && !store.abTestFirstStep ? "2" : "";
	pushEvent(store.isModal ? "GoogleBtnClick" : `GoogleButton${suffix}`);
}

function startOcmLogin(googleUser: google.accounts.id.CredentialResponse) {
	const authorationData = {
		tokenId: googleUser.credential,
		formId: "#google-login-form",
	};

	authenticate(authorationData, "google");
	// .then((ok) => console.log("googleLogin", ok));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "googleButton",
    ref: googleButton,
    class: "m-2 h-10 w-10"
  }, null, 512))
}
}

})